// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 40px 16px;
  border: 1px dashed rgba(var(--ion-color-medium-rgb), 0.35);
  border-radius: 14px;
  background: var(--ion-background-color, #fff);
  text-align: center;
}
.empty-state--plain {
  padding: 28px 12px;
  border: 0;
  background: transparent;
}

.empty-state__icon {
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  margin-bottom: 4px;
  border-radius: 50%;
  background: rgba(var(--ion-color-primary-rgb), 0.1);
  color: var(--ion-color-primary);
}
.empty-state__icon ion-icon {
  font-size: 28px;
}

.empty-state__title {
  margin: 0;
  max-width: 360px;
  font-size: 15px;
  font-weight: 600;
  color: var(--ion-text-color, #000);
}

.empty-state__description {
  margin: 0;
  max-width: 360px;
  font-size: 14px;
  line-height: 1.45;
  color: var(--ion-color-medium);
}

/* Projected action(s), e.g. an "Add" button */
.empty-state__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 6px;
}
.empty-state__actions:empty {
  display: none;
}
.empty-state__actions ::ng-deep ion-button {
  --border-radius: 10px;
  --box-shadow: none;
  margin: 0;
  text-transform: none;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/empty-state/empty-state.component.scss","webpack://./src/components/general%20components/empty-state/empty-state.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;ACCF;;ADEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,0DAAA;EACA,mBAAA;EACA,6CAAA;EACA,kBAAA;ACCF;ADCE;EACE,kBAAA;EACA,SAAA;EACA,uBAAA;ACCJ;;ADGA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mDAAA;EACA,+BAAA;ACAF;ADEE;EACE,eAAA;ACAJ;;ADIA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;ACDF;;ADIA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;ACDF;;ADIA,8CAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;ACDF;ADGE;EACE,aAAA;ACDJ;ADIE;EACE,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;ACFJ","sourcesContent":[":host {\n  display: block;\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 40px 16px;\n  border: 1px dashed rgba(var(--ion-color-medium-rgb), 0.35);\n  border-radius: 14px;\n  background: var(--ion-background-color, #fff);\n  text-align: center;\n\n  &--plain {\n    padding: 28px 12px;\n    border: 0;\n    background: transparent;\n  }\n}\n\n.empty-state__icon {\n  display: grid;\n  place-items: center;\n  width: 56px;\n  height: 56px;\n  margin-bottom: 4px;\n  border-radius: 50%;\n  background: rgba(var(--ion-color-primary-rgb), 0.1);\n  color: var(--ion-color-primary);\n\n  ion-icon {\n    font-size: 28px;\n  }\n}\n\n.empty-state__title {\n  margin: 0;\n  max-width: 360px;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--ion-text-color, #000);\n}\n\n.empty-state__description {\n  margin: 0;\n  max-width: 360px;\n  font-size: 14px;\n  line-height: 1.45;\n  color: var(--ion-color-medium);\n}\n\n/* Projected action(s), e.g. an \"Add\" button */\n.empty-state__actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 6px;\n\n  &:empty {\n    display: none;\n  }\n\n  ::ng-deep ion-button {\n    --border-radius: 10px;\n    --box-shadow: none;\n    margin: 0;\n    text-transform: none;\n    font-weight: 600;\n  }\n}\n",":host {\n  display: block;\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 40px 16px;\n  border: 1px dashed rgba(var(--ion-color-medium-rgb), 0.35);\n  border-radius: 14px;\n  background: var(--ion-background-color, #fff);\n  text-align: center;\n}\n.empty-state--plain {\n  padding: 28px 12px;\n  border: 0;\n  background: transparent;\n}\n\n.empty-state__icon {\n  display: grid;\n  place-items: center;\n  width: 56px;\n  height: 56px;\n  margin-bottom: 4px;\n  border-radius: 50%;\n  background: rgba(var(--ion-color-primary-rgb), 0.1);\n  color: var(--ion-color-primary);\n}\n.empty-state__icon ion-icon {\n  font-size: 28px;\n}\n\n.empty-state__title {\n  margin: 0;\n  max-width: 360px;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--ion-text-color, #000);\n}\n\n.empty-state__description {\n  margin: 0;\n  max-width: 360px;\n  font-size: 14px;\n  line-height: 1.45;\n  color: var(--ion-color-medium);\n}\n\n/* Projected action(s), e.g. an \"Add\" button */\n.empty-state__actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 6px;\n}\n.empty-state__actions:empty {\n  display: none;\n}\n.empty-state__actions ::ng-deep ion-button {\n  --border-radius: 10px;\n  --box-shadow: none;\n  margin: 0;\n  text-transform: none;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
